import useTab from '../../hooks/useTab'
import useCategory from './Category/useCategory'
import useDestiny from './Destiny/useDestiny'
import useItem from './Letter/useItem'
import useFeature from './Feature/useFeature'
import useSupply from './Supply/useSupply'
import useModifier from './Modifier/useModifier'
import useModifierGroup from './ModifierGroup/useModifierGroup'
import useCombo from './Combo/useCombo'

export default function useControl() {
    const openModalCategory = useCategory()
    const openModalDestiny = useDestiny()
    const openModalItem = useItem()
    const openModalFeature = useFeature()
    const openModalSupply = useSupply()
    const openModalModifier = useModifier()
    const openModalModifierGroup = useModifierGroup()
    const openModalCombo = useCombo()

    const props = useTab('item')

    function openModal() {
        console.log('p', props.value)
        if (props.value === 'item') {
            openModalItem()
        }
        if (props.value === 'category') {
            openModalCategory()
        }
        if (props.value === 'destiny') {
            openModalDestiny()
        }
        if (props.value === 'supply') {
            openModalSupply()
        }
        if (props.value === 'feature') {
            openModalFeature()
        }
        if (props.value === 'modifier') {
            openModalModifier()
        }
        if (props.value === 'modifier_group') {
            openModalModifierGroup()
        }
        if (props.value === 'combo') {
            openModalCombo()
        }
    }

    function getTextButton() {
        switch (props.value) {
            case 'item':
                return 'Nuevo producto'
            case 'category':
                return 'Nueva categoría'
            case 'supply':
                return 'Nuevo insumo'
            case 'feature':
                return 'Nueva característica'
            case 'modifier':
                return 'Nuevo modificador'
            case 'modifier_group':
                return 'Nuevo grupo de modificador'
            case 'combo':
                return 'Nuevo combo'
            default:
                return 'Nuevo destino de preparación'
        }
    }

    return {
        openModal,
        getTextButton,
        tabProps: props
    }
}
